import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';

import Slider from 'react-slick';

// Import client   Image
import person1 from '../assets/images/Person-1.png';
import person2 from '../assets/images/Person-2.png';
import person3 from '../assets/images/Person-3.png';
import prev from '../assets/images/Icon-1.png';
import next from '../assets/images/Icon.png';

export default class Clients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [
        {
          id: 1,
          quotes:
            'Terima Kasih kepada DESAPEDIA karena telah membuat seluruh program kita lebih praktis',
          img: person1,
          name: 'Randi Arnofan',
          designation: 'Kepala Desa Lubuk Batang Baru',
        },
        {
          id: 2,
          quotes:
            'Alhamdulillah, setelah menggunakan DESAPEDIA semua layanan jadi lebih mudah',
          img: person2,
          name: 'Yulia Hertati',
          designation: 'Ketua Ibu PKK',
        },
        {
          id: 3,
          quotes:
            'Sistem DESAPEDIA sangat membantu desa kamu dalam pelayanan desa',
          img: person3,
          name: 'Al Amin Musodik A.Md',
          designation: 'Sekertaris Desa',
        },
        {
          id: 1,
          quotes:
            'Terima Kasih kepada DESAPEDIA karena telah membuat seluruh program kita lebih praktis',
          img: person1,
          name: 'Randi Arnofan',
          designation: 'Kepala Desa Lubuk Batang Baru',
        },
        {
          id: 2,
          quotes:
            'Alhamdulillah, setelah menggunakan DESAPEDIA semua layanan jadi lebih mudah',
          img: person2,
          name: 'Yulia Hertati',
          designation: 'Ketua Ibu PKK',
        },
        {
          id: 3,
          quotes:
            'Sistem DESAPEDIA sangat membantu desa kamu dalam pelayanan desa',
          img: person3,
          name: 'Al Amin Musodik A.Md',
          designation: 'Sekertaris Desa',
        },
      ],
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  render() {
    var settings = {
      dots: true,
      speed: 300,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      centerPadding: '20px',
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 3,
            infinite: true,
            centerPadding: '20px',
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            infinite: true,
            centerPadding: '20px',
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 1,
            infinite: true,
            centerPadding: '20px',
          },
        },
      ],
    };

    const slides = this.state.items.map((item, key) => {
      return (
        <div className='item' key={key}>
          <div className='testi-box text-center m-2'>
            <div className='test-user-info'>
              <div className='card-color'>
                <div className='card-white mx-auto'>
                  <div className='quotes-cover'>
                    <span className=''>"</span>
                    <p className='quotes'>{item.quotes}</p>
                  </div>
                  <img
                    src={item.img}
                    alt=''
                    className='mx-auto img-fluid d-block rounded-circle testi-user-img'
                  />
                  <h5 className='user mx-auto mt-3 mb-1'>{item.name}</h5>
                  <h5 className='info'>{item.designation}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });

    return (
      <React.Fragment>
        <section className='section' id='clients'>
          <Container>
            <Row className='justify-content-center'>
              <Col lg={7}>
                <div className='text-center mb-5'>
                  <h2 className=''>Apa Kata Aparat Desa?</h2>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div
                  id='testi-clients'
                  className='owl-carousel owl-theme testi-content'
                >
                  <button className='prev' onClick={() => this.previous()}>
                    <div className='btn-white'>
                      <img src={prev} alt='' />
                    </div>
                  </button>
                  <Slider ref={(c) => (this.slider = c)} {...settings}>
                    {slides}
                  </Slider>
                  <button className='next' onClick={() => this.next()}>
                    <div className='btn-white'>
                      <img src={next} alt='' />
                    </div>
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
